import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaTabletPromo',
			dom: {
				slides: '.js-tablet-promo-slides',
				slide: '.js-tablet-promo-slide'
			},
			classes: {
				slide: {
					slide: 'b-tablet-promo__slide',
					active: 'b-tablet-promo__slide_state_active'
				}
			},
			timeout: 4000
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$slides = this.$el.find(this.options.dom.slides);
		this.$slide = this.$el.find(this.options.dom.slide);
		return this;
	}

	startShow() {
		const self = this;
		this.show = setInterval(function () {
			const $activeSlide = self.$slide.filter('.' + self.options.classes.slide.active);
			const $nextSlide = $activeSlide.next('.' + self.options.classes.slide.slide);
			self.$slide.removeClass(self.options.classes.slide.active);

			if ($nextSlide.hasClass(self.options.classes.slide.slide)) {
				$nextSlide.addClass(self.options.classes.slide.active);
			} else {
				self.$slide.first().addClass(self.options.classes.slide.active);
			}
		}, self.options.timeout);
	}


	render() {
		if (this.$el.length) {
			this.getDom();
			this.startShow();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/tablet-promo/tablet-promo.js